module.exports = __webpack_public_path__ + "img/file-earmark-richtext.e2f3a89e.svg";